<div class="form-modal modal-theme">
  <h1 mat-dialog-title>{{'GRAPHICS'|translate}}</h1>
  <div mat-dialog-content>
    <div class="form-horizontal modal-dialog-custom">
      <div class="row">

        <!-- Paineis -->
        <div *ngFor="let panel of panels; let i=index" [class]="panel.PanelSize">
          <div class="panel panel-default">
            <div class="panel-heading clearfix pointer" data-toggle="collapse" [attr.data-target]="'#collPnNavBarCharts_'+i"
              (click)="collPnNavBarCharts[i] = !collPnNavBarCharts[i]" *ngIf="panel.PanelLabel">
              <h5 class="panel-title">
                <i [class]="panel.PanelIcon" *ngIf="panel.PanelIcon"></i>
                <strong>{{panel.PanelLabel}}</strong>
                <i class="collapse-icon fas"
                  [ngClass]="{'fa-caret-down': collPnNavBarCharts[i], 'fa-caret-up': !collPnNavBarCharts[i]}"></i>
              </h5>
            </div>
            <div [id]="'collPnNavBarCharts_'+i" class="panel-body no-horizontal-padding collapse in">
              <div class="form-group">

                <div *ngFor="let chart of panel.Charts; let i=index">
                  <!-- Line, Bar e Radar -->
                  <app-multiserie-chart [chart]="chart"
                    *ngIf="chart.ChartType === 'line' || chart.ChartType === 'bar' || chart.ChartType === 'radar'">
                  </app-multiserie-chart>

                  <!-- Pie, Polar Area e Doughnut -->
                  <app-uniserie-chart [chart]="chart"
                    *ngIf="chart.ChartType === 'pie' || chart.ChartType === 'polarArea' || chart.ChartType === 'doughnut'">
                  </app-uniserie-chart>

                  <!-- Counter -->
                  <app-counter-chart [chart]="chart" *ngIf="chart.ChartType === 'counter'"></app-counter-chart>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" title="{{'CLOSE' | translate}}" (click)="dialogRef.close(null)">
        {{'CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>